export const SEEDS_MODULE_NAME = "seeds";
